import ApiClient from './apiClient'
import {
  Member,
  AddMemberRequest,
  EditMemberRequest,
  GetMemberListResponse,
  Profile,
  EditProfileRequest,
  AddMultiMembersRequest,
  GetOccupationListResponse,
  GetWorkCategoryListResponse,
  PatchWorkCategoriesRequest,
  PostInviteMembersRequest,
} from '../types/member'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMemberList = async (): Promise<any> => ApiClient.get(
  '/api/setting/member',
  (memberList: GetMemberListResponse) => memberList,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postMember = async (params: AddMemberRequest): Promise<any> => ApiClient.post(
  '/api/setting/member',
  (member: Member) => member,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchMember = async (memberId: number, params: EditMemberRequest): Promise<any> => ApiClient.patch(
  `/api/setting/member/${memberId}`,
  (result: Member) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteMember = async (memberId: number): Promise<any> => ApiClient.delete(
  `/api/setting/member/${memberId}`,
  (result: Record<string, unknown>) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const passwordReset = async (memberId: number): Promise<any> => ApiClient.patch(
  `/api/v1/features/password/init/${memberId}`,
  (result: Record<string, unknown>) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getProfile = async (): Promise<any> => ApiClient.get(
  '/api/setting/profile',
  (profile: Profile) => profile,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchProfile = async (params: EditProfileRequest): Promise<any> => ApiClient.patch(
  '/api/setting/profile',
  (profile: Profile) => profile,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postImportMembers = async (params: AddMultiMembersRequest): Promise<any> => ApiClient.post(
  '/api/v1/features/import/csv/members',
  (members: Member[]) => members,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getOccupationList = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/occupation',
  (occupationList: GetOccupationListResponse) => occupationList,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchOccupation = async (params: {occupation_id: number}): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/profile/occupation',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchProfileImage = async (params: {image: string}): Promise<any> => ApiClient.patch(
  '/api/v1/features/setting/profile/image',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteProfileImage = async (): Promise<any> => ApiClient.delete(
  '/api/v1/features/setting/profile/image',
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteMemberMfa = async (memberId: number): Promise<any> => ApiClient.delete(
  `/api/v3/features/setting/member/mfa_auth/${memberId}`,
  (result: Record<string, unknown>) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWorkCategoryList = async (): Promise<any> => ApiClient.get(
  '/api/setting/work_category',
  (response: GetWorkCategoryListResponse) => response,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchWorkCategories = async (params: PatchWorkCategoriesRequest): Promise<any> => ApiClient.patch(
  '/api/setting/work_category',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postInviteMembers = async (params: PostInviteMembersRequest): Promise<any> => ApiClient.post(
  '/api/setting/send_invite_mail',
  () => {
    // do nothing
  },
  params,
)
